import {observer} from "mobx-react-lite";
import React, {useContext} from "react";
import {StateContext} from "../App";
import {useRouterStore} from "mobx-state-router";
import {Button, Col, InputGroup, UncontrolledTooltip} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRotateLeft} from "@fortawesome/free-solid-svg-icons";
import {FormattedMessage} from "react-intl";

const ResetButton = observer(({viewState}) => {
  const stateContext = useContext(StateContext);
  const routerStore = useRouterStore();

  return(
    <>
      <Col sm={1}>
        <div></div>
      </Col>
      <Col sm={1} className="reset-button-col">
        <InputGroup className={"justify-content-end"}>
          <Button id="filter-rest-button" color="primary" onClick={()=>viewState?.clearFilters()}>
            <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
        </InputGroup>
      </Col>
      <UncontrolledTooltip target="filter-rest-button" placement="top">
        <FormattedMessage id="createQr.resetBtn.defaultMessage"/>
      </UncontrolledTooltip>
    </>
  );
});

export default ResetButton;
